export const MILLISECONDS_IN_SECOND = 1000
